import { CerFormViewSet } from '@cer/cer-form/cer-form-view-set';
import { CerFormAdapter } from '@cer/cer-form/cer-form-adapter';
import { CerFormView } from '@cer/cer-form/cer-form-view';
import { FieldWidthEnum } from 'src/cer/cer-data/cer-data-types';

export class VoucherApprovalPolicyForm extends CerFormAdapter {

  public override viewSetInit(viewSet: CerFormViewSet): void {
    const view = new CerFormView({
      viewMetadata: {
        name: 'voucher-approval-policy', dataApiName: 'VoucherApprovalPolicy', text: 'Godkendelsespolitik',
        primaryKey: 'id', titleFields: ['name'], baseFields: ['id', 'name', 'history']
      },
      fieldMetadata: [
        { name: 'channel', text: 'Kanal', tooltipText: 'Bilagskanal', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyTableName: 'VoucherMessageChannel' },
        { name: 'amountCur', text: 'Beløb', tooltipText: 'Minimumsbeløb', allowEdit: true, defaultValue: '', allowEditOnAdd: true, format: 'Amount' },
        { fieldType: 'currency', tooltipText: 'Valuta for minimumsbeløb', allowEdit: true, defaultValue: '', allowEditOnAdd: true },
        { name: 'approvalCount', text: 'Antal godkendelser', tooltipText: 'Antal godkendere', allowEdit: true, defaultValue: 2, allowEditOnAdd: true, format: 'Integer' },
        { name: 'active', text: 'Aktiv', tooltipText: 'Er aktiv godkender', allowEdit: true, allowEditOnAdd: true, defaultValue: true, format: 'CheckBox' },
      ]
    });
    viewSet.viewAdd(view);

    const viewApprovers = new CerFormView({
      viewMetadata: {
        name: 'voucher-approval-policy-user', dataApiName: 'VoucherApprovalPolicyUser', text: 'Godkendelsespolitik godkendere',
        primaryKey: 'id', parentPrimaryKey: 'id', parentForeignKey: 'policy', titleFields: ['policy', 'userId'], baseFields: ['id', 'history']
      },
      fieldMetadata:
        [
          { name: 'policy', text: 'Politik', tooltipText: 'Bilagskanal', required: true, allowEdit: true, allowEditOnAdd: true, foreignKeyField: 'id', foreignKeyValue: 'name', foreignKeyTableName: 'VoucherApprovalPolicy', visible: false, visibleAdd: false },
          { name: 'approver', text: 'Godkender', tooltipText: 'Godkender', required: true, allowEdit: true, allowEditOnAdd: true, widthType: FieldWidthEnum.M, foreignKeyField: 'id', foreignKeyValue: 'shortName', foreignKeyTableName: 'User', foreignKeyTableParams: ['$filterSystemRows'] },
          { name: 'priority', text: 'Prioritet', tooltipText: 'Prioritet (1=Høj)', allowEdit: true, defaultValue: 1, allowEditOnAdd: true, format: 'Integer', orderBy: 'Ascending', orderByPriority: 2 },
          { name: 'active', text: 'Aktiv', tooltipText: 'Er aktiv godkender', allowEdit: true, allowEditOnAdd: true, defaultValue: true, format: 'CheckBox', orderBy: 'Descending', orderByPriority: 1 }
        ]
    });
    viewSet.viewAdd(viewApprovers, view);
  }
}
